import React, { useEffect } from 'react';

import { AppBar, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormGroup, IconButton, Switch, TextField, Toolbar, Typography } from '@mui/material';
import { AccountCircle, Cached, Edit, ExitToApp, LockReset, PersonAdd, PersonOff, SupervisorAccount } from '@mui/icons-material';

import './StaffMaster.css';
import { useAuth } from './AuthContext';
import { useAuthAjax, useStaffsAjax } from './Ajax';

export const StaffMaster = () => {
    const { state:authState, modeNormal } = useAuth();
    const { getStaffs } = useStaffsAjax();
    const [ staffs, setStaffs ] = React.useState();

    const handleReload = React.useCallback(() => {
        getStaffs()
        .then((res) => {
            // console.log(res.data);
            setStaffs(res.data);
        });
    }, [getStaffs]);
    useEffect(()=>{ handleReload(); }, [handleReload]);

    const handleExitToApp = React.useCallback(() => { modeNormal(); }, [modeNormal]);

    const staffDialog = React.useRef();
    const handlePersnoAdd = React.useCallback(() => {
        // TODO: 新規作成
        staffDialog.current.createStaff();
    }, []);
    const handlePersonMod = React.useCallback((staff) => {
        staffDialog.current.modifyStaff(staff);
    }, []);

    return (
        <Box sx={{flexGrow: 1}}>
            <AppBar position="static" className='noPrint'>
                <Toolbar>
                    <Typography variant='h6' component="div">健診予約 スタッフ管理</Typography>

                    <Divider orientation='vertical' flexItem sx={{flexGrow:1}}/>

                    <IconButton size="large" color="inherit" onClick={handleReload}>
                        <Cached/>
                    </IconButton>

                    <IconButton size="large" color="inherit" onClick={handleExitToApp}>
                        <ExitToApp/>
                    </IconButton>

                    {/* <Divider orientation='vertical' flexItem sx={{flexGrow:1}}/> */}

                    <IconButton size="large" color="inherit" onClick={handlePersnoAdd}>
                        <PersonAdd/>
                    </IconButton>

                    <Divider orientation='vertical' flexItem sx={{flexGrow:1}}/>
                    <IconButton size='large'
                        color="inherit">
                        <AccountCircle/>
                    </IconButton>
                    {authState.name}
                </Toolbar>
            </AppBar>
            { (!staffs || staffs.length<=0) ? <h2>NO DATA</h2> : 
            <table className='staffTable'>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>職員番号</th>
                        <th>名前</th>
                        {/* <th>パスワード</th> */}
                        <th>権限</th>
                        <th colSpan={3}>操作</th>
                    </tr>
                </thead>
                <tbody>
                    {staffs.map((staff, i)=>(
                        <StaffTableRow key={staff.id} staff={staff} idx={i} reload={handleReload} modify={handlePersonMod}/>
                    ))}
                </tbody>
            </table> }
            <StaffDialog onChange={handleReload} ref={staffDialog}/>
        </Box>
    );
}

const StaffTableRow = ({staff, idx, reload, modify}) => {
    const { staffEnable, staffDisable, resetPassword } = useStaffsAjax();

    const className = (staff.deleted ? 'delete' : '');
    const adminIcon = (staff.sauth==="admin" ? <SupervisorAccount/> : null);

    const handleEdit = React.useCallback(() => {
        // TODO: 内容を変更する
        modify(staff);
    }, [staff, modify]);

    const handleReset = React.useCallback(() => {
        const confirm = window.confirm("パスワードを初期値「0000」にリセットしますか？");
        if(confirm) {
            // TODO: パスワードをリセットする
            resetPassword(staff.scode)
            .then((res)=>{
                window.alert("パスワードを初期値「0000」にリセットしました。");
            });
        }
    }, [staff, resetPassword]);

    const handlePersonOnOff = React.useCallback(() => {
        if(staff.deleted) {
            const confirm = window.confirm("このアカウントを有効にしてもよろしいですか？");
            if(confirm) {
                // TODO: 有効にする
                staffEnable(staff.scode)
                .then((res)=>{
                    window.alert("このアカウントを有効にしました。");
                    reload();
                });
            }
        } else {
            const confirm = window.confirm("このアカウントを無効にしてもよろしいですか？");
            if(confirm) {
                // TODO: 無効にする
                staffDisable(staff.scode)
                .then((res)=>{
                    window.alert("このアカウントを無効にしました。");
                    reload();
                });
            }
        }
    }, [staff, reload, staffEnable, staffDisable]);

    return (
        <tr key={staff.scode} className={className}>
            <td>{idx+1}</td>
            <td>{staff.scode}</td>
            <td>{staff.sname}</td>
            {/* <td>{staff.spass}</td> */}
            <td>{adminIcon}</td>
            <td><IconButton size='large' color="inherit" onClick={handleEdit}><Edit/></IconButton></td>
            <td><IconButton size='large' color="inherit" onClick={handleReset}><LockReset/></IconButton></td>
            <td><IconButton size='large' color="inherit" onClick={handlePersonOnOff}><PersonOff/></IconButton></td>
        </tr>
    );
}

const StaffDialog = React.forwardRef((props, ref) => { // forwardRef
    const { onChange } = props;

    const { createStaff:createStaffAjax, modifyStaff:modifyStaffAjax } = useStaffsAjax();

    const [ staff, setStaff ] = React.useState(null);
    const handleChange = React.useCallback((e) => {
        setStaff((staff)=>({...staff, [e.target.name]:e.target.value}));
    }, []);
    const handleChangeCheck = React.useCallback((e) => {
        setStaff((staff)=>({...staff, [e.target.name]:e.target.checked?e.target.value:''}));
    }, []);

    const createStaff = React.useCallback(() => { setStaff({
        id: null,
        scode: "",
        sname: "",
        sauth: "",
    }); }, [])
    const modifyStaff = React.useCallback((staff) => { setStaff(staff); }, [])
    // const openDialog = React.useCallback((staff) => { setStaff(staff); }, [])
    const closeDialog = React.useCallback(() => { setStaff(null); }, [])

    React.useImperativeHandle(ref, () => ({ createStaff, modifyStaff })); // forwardRef

    const close = React.useCallback(() => { setStaff(null); }, []);
    const handleCancel = React.useCallback(() => { close(); }, [close]);

    const handleSave = React.useCallback(() => {
        // console.log(staff);
        if(!staff.scode.trim()) { window.alert("職員番号を入力してください。"); return; }
        if(!staff.sname.trim()) { window.alert("氏名を入力してください。"); return; }

        // if(staff.id) {
        //     modifyStaffAjax()

        // } else {

        // }
        const staffAjax = staff.id ? modifyStaffAjax : createStaffAjax;
        staffAjax(staff)
        .then((res)=>{
            onChange(); // reload
            close();
        });

    }, [staff, onChange, close, createStaffAjax, modifyStaffAjax]);


    const isOpen = React.useMemo(() => (staff ? true : false), [staff]);

    if(!isOpen) return null;
    return (
        <Dialog onClose={closeDialog} open={isOpen} fullWidth={true} maxWidth='xs'>
            <DialogTitle>編集</DialogTitle>
            <DialogContent>
                <FormControl valiant="outlined" sx={{m:2}}>
                    <TextField label="職員番号" name="scode" value={staff.scode} onChange={handleChange} disabled={staff.id ? false : false}/>
                </FormControl>
                <FormControl valiant="outlined" sx={{m:2}}>
                    <TextField label="氏名" name="sname" value={staff.sname} onChange={handleChange}/>
                </FormControl>
                {/* <FormControl valiant="outlined" sx={{m:2}}>
                    <Switch label="管理者" onChange={handleChangeCheck}/>
                </FormControl> */}
                <FormGroup>
                    <FormControlLabel control={<Switch name='sauth' checked={staff.sauth==='admin'} onChange={handleChangeCheck}/>} value='admin' label={staff.sauth==='admin'?'管理者':'一般'}/>
                </FormGroup>

            </DialogContent>
            <DialogActions>
                <Button onClick={handleSave} variant="contained">保存</Button>
                <Button onClick={handleCancel} variant="outlined">キャンセル</Button>
            </DialogActions>
        </Dialog>
    );
});

export const PasswordDialog = React.forwardRef((props, ref) => { // forwardRef
    const { onChange } = props;

    const { chPasswd } = useAuthAjax();

    const [ staff, setStaff ] = React.useState(null);
    const handleChange = React.useCallback((e) => {
        setStaff((staff)=>({...staff, [e.target.name]:e.target.value}));
    }, []);
    // const handleChangeCheck = React.useCallback((e) => {
    //     setStaff((staff)=>({...staff, [e.target.name]:e.target.checked?e.target.value:''}));
    // }, []);

    // const createStaff = React.useCallback(() => { setStaff({
    //     id: null,
    //     scode: "",
    //     sname: "",
    //     sauth: "",
    // }); }, [])
    const modifyPassword = React.useCallback((auth) => { setStaff({id: auth.id, scode: auth.code, sname: auth.name, spass1: "", spass2: "" }); }, [])
    // const openDialog = React.useCallback((staff) => { setStaff(staff); }, [])
    const closeDialog = React.useCallback(() => { setStaff(null); }, [])

    React.useImperativeHandle(ref, () => ({ modifyPassword })); // forwardRef

    const close = React.useCallback(() => { setStaff(null); }, []);
    const handleCancel = React.useCallback(() => { close(); }, [close]);

    const handleSave = React.useCallback(() => {
        // console.log(staff);
        // if(!staff.scode.trim()) { window.alert("職員番号を入力してください。"); return; }
        if(!staff.sname.trim()) { window.alert("氏名を入力してください。"); return; }

        if(staff.spass1.trim()!==staff.spass2.trim()) { window.alert("パスワードが一致していません。"); return; }
        if(!staff.spass1.trim()) { window.alert("パスワードを入力してください。"); return; }

        // if(staff.id) {
        //     modifyStaffAjax()

        // } else {

        // }
        // const staffAjax = staff.id ? modifyStaffAjax : createStaffAjax;
        chPasswd(staff.id, staff.scode, staff.sname, staff.spass1)
        .then((res)=>{
            window.alert("名前を変更した場合は\n一度ログアウトしてください。");
            if(onChange) onChange(); // reload
            close();
        });

    }, [staff, onChange, close, chPasswd]);


    const isOpen = React.useMemo(() => (staff ? true : false), [staff]);

    if(!isOpen) return null;
    return (
        <Dialog onClose={closeDialog} open={isOpen} fullWidth={true} maxWidth='xs'>
            <DialogTitle>名前とパスワードの変更</DialogTitle>
            <DialogContent>
                {/* <FormControl valiant="outlined" sx={{m:2}}>
                    <TextField label="職員番号" name="scode" value={staff.scode} onChange={handleChange} disabled={staff.id ? false : false}/>
                </FormControl> */}
                <FormControl valiant="outlined" sx={{m:2}}>
                    <TextField label="氏名" name="sname" value={staff.sname} onChange={handleChange}/>
                </FormControl>

                <FormControl valiant="outlined" sx={{m:2}}>
                    <TextField label="パスワード" name="spass1" value={staff.spass1} onChange={handleChange} type="password"/>
                </FormControl>
                <FormControl valiant="outlined" sx={{m:2}}>
                    <TextField label="パスワード（確認）" name="spass2" value={staff.spass2} onChange={handleChange} type="password"/>
                </FormControl>

            </DialogContent>
            <DialogActions>
                <Button onClick={handleSave} variant="contained">保存</Button>
                <Button onClick={handleCancel} variant="outlined">キャンセル</Button>
            </DialogActions>
        </Dialog>
    );
});
